/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/subscribe/getresponse'>.
 * статик-сегмент, приоритет над $hash
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Subscribe from '@routes/Subscribe';

export const Route = createFileRoute('/subscribe/getresponse')({
  /**
   * ЭТАП 2 (решение Sergei, 29.08.2026): страница ТОЛЬКО SPA.
   *
   * Это транзакционный адрес из письма, а не контент: вся его работа —
   * эффект, который читает `location.href`, и дальше либо подтверждает
   * подписку по `id` из query, либо перекидывает на `/subscribe/<email>`.
   * Серверу тут нечего отрисовать: до выполнения эффекта страница пуста,
   * а отдавать поисковику «Спасибо, что присоединились» — вредно.
   *
   * `ssr: false` — штатный механизм TanStack (SSROption), роут целиком
   * рендерится на клиенте: сервер отдаёт оболочку без его разметки.
   * Отличие от остальной SPA-группы в чек-листе: там страницы просто не
   * префетчатся, но сервер их всё же рендерит; здесь рендер отключён.
   *
   * Побочный эффект: мета (CacheDataRoute -> meta.get) тоже становится
   * клиентской — для страницы, которую не индексируют, это нормально.
   */
  ssr: false,
  component: () => (
    <CacheDataRoute component={Subscribe} path='/subscribe/getresponse' />
  )
});
